// extracted by mini-css-extract-plugin
export default {"trimGhost":"ogYPKfyhQVf1OddtmHNT","waveform":"yI0vRJVe8V9AE2VgXrpP","trimGhostWaveform":"R69XZ2G5pVSSzRRH8Et_"};